<template>
<div class="chapter">
<div class="inner_page">
<div class="alsoby">
<a id="title2"></a><div class="title-alsoby"><em class="i"><strong class="b">Books by Jacqueline Baird</strong></em></div>
<div class="p-br"><span>HARLEQUIN PRESENTS<sup>®</sup> <br/>1876—RAUL’S REVENGE <br/>1915—MISTAKEN FOR A MISTRESS <br/>1942—THE RELUCTANT FIANCÉE</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p"><span>Don’t miss any of our special offers. Write to us at the following address for Information on our newest releases.</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p-br"><span>Harlequin Reader Service <br/>U.S.: 3010 Walden Ave., P.O. Box 1325, Buffalo, NY 14269 <br/>Canadian: P.O. Box 609, Fort Erie, Ont. L2A 5X3</span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781459251816_als01.vue?5a8c1df7